export enum RatingScaleDesign {
  Numerical,
  Emoji,
  Star,
}
